import React from 'react'
import styled from 'styled-components/macro'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Autoplay, Pagination } from 'swiper'

import 'swiper/css'
import 'swiper/css/pagination'

import { useContactModal } from '../../context/ContactModalContext'

// Импорт баннеров по языкам
import ru1 from '../../assets/banners/ru/1.webp'
import ru2 from '../../assets/banners/ru/2.webp'
import ru3 from '../../assets/banners/ru/3.webp'
import ru4 from '../../assets/banners/ru/4.webp'

import en1 from '../../assets/banners/en/1.webp'
import en2 from '../../assets/banners/en/2.webp'
import en3 from '../../assets/banners/en/3.webp'
import en4 from '../../assets/banners/en/4.webp'

SwiperCore.use([Autoplay, Pagination])

const BANNERS_MAP = {
  ru: [ru1, ru2, ru3, ru4],
  en: [en1, en2, en3, en4],
}

const Section = styled.section`
  width: 100%;
  max-width: 1200px;
  margin: 2rem auto 1rem auto;
  position: relative;

  @media (max-width: 577px) {
    margin: 0 auto 0.5rem auto;
  }

  .swiper-pagination {
    bottom: 0;
  }

  .swiper-pagination-bullet {
    border: 0.5px solid rgba(241, 220, 217, 1);
    background: rgba(255, 255, 255, 1);
    opacity: 1;
  }

  .swiper-pagination-bullet-active {
    background: rgba(241, 220, 217, 1);
    border: 0.5px solid rgba(241, 220, 217, 1);
  }
`

const StyledSwiper = styled(Swiper)`
  width: 100%;
  padding-bottom: 28px;
`

const SlideWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  cursor: ${(props) => (props.isClickable ? 'pointer' : 'default')};

  img {
    width: 100%;
    height: auto;
    object-fit: cover;
    display: block;
    border-radius: 16px;

    @media (max-width: 577px) {
      border-radius: 0;
    }
  }
`

const Banner = () => {
  const { i18n } = useTranslation()
  const navigate = useNavigate()
  const { openContactModal } = useContactModal()

  const lang = i18n.language?.slice(0, 2)
  const currentBanners = BANNERS_MAP[lang] || BANNERS_MAP.ru

  const handleBannerClick = (index) => {
    switch (index) {
      case 0: {
        const worksSection = document.getElementById('works')
        if (worksSection) {
          worksSection.scrollIntoView({ behavior: 'smooth' })
        } else {
          window.scrollTo({ top: window.innerHeight * 0.8, behavior: 'smooth' })
        }
        break;
      }
      case 2: {
        navigate('/show')
        break;
      }
      case 3: {
        openContactModal()
        break;
      }
      default:
        break
    }
  }

  return (
    <Section>
      <StyledSwiper
        spaceBetween={16}
        slidesPerView={1}
        slidesPerGroup={1}
        loop={true}
        autoplay={{
          delay: 6000,
          disableOnInteraction: false,
        }}
        speed={1000}
        pagination={{ clickable: true }}
        breakpoints={{
          578: {
            slidesPerView: 2,
            slidesPerGroup: 2,
            spaceBetween: 20,
          },
        }}
      >
        {currentBanners.map((bannerImg, index) => {
          const isClickable = index === 0 || index === 2 || index === 3

          return (
            <SwiperSlide key={index}>
              <SlideWrapper
                isClickable={isClickable}
                onClick={() => handleBannerClick(index)}
              >
                <img src={bannerImg} alt={`banner-${index + 1}`} />
              </SlideWrapper>
            </SwiperSlide>
          )
        })}
      </StyledSwiper>
    </Section>
  )
}

export default Banner